import { useIntlayer } from 'react-intlayer';

import { FadeIn } from '~/components/ui/fade-in';
import { Typography } from '~/components/ui/typography';

export const IntroductionSection = () => {
  const { introduction } = useIntlayer('landing');

  return (
    <section className="bg-graphite-100 px-4 lg:px-20 py-20 lg:py-40">
      <div className="flex flex-col lg:flex-row items-start justify-between gap-8 lg:gap-0">
        {/* Section label */}
        <FadeIn>
          <Typography
            as="p"
            variant="label"
            className="text-black leading-normal"
          >
            {introduction.whatWeDo.subtitle}
          </Typography>
        </FadeIn>

        {/* Content column */}
        <div className="flex flex-col gap-10 md:gap-[60px] md:max-w-[737px] md:pr-[110px]">
          <FadeIn delay={0.1}>
            <p className="font-manrope font-normal text-[30px] md:text-4xl leading-normal text-black">
              <span>{introduction.whatWeDo.heading.part1}</span>
              <span className="text-graphite-700">
                {introduction.whatWeDo.heading.highlighted}
              </span>
              <span>{introduction.whatWeDo.heading.part2}</span>
            </p>
          </FadeIn>

          {/* Body paragraphs — 16px Manrope, 1.5 line-height */}
          <div className="flex flex-col gap-5 w-full lg:w-[628px]">
            <FadeIn delay={0.2}>
              <p className="font-sans font-normal text-black text-base leading-[1.5] tracking-[0.16px]">
                {introduction.whatWeDo.body.p1}
              </p>
            </FadeIn>
            <FadeIn delay={0.25}>
              <p className="font-sans font-normal text-black text-base leading-[1.5] tracking-[0.16px]">
                {introduction.whatWeDo.body.p2}
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
};
